import {FieldEvent} from './settings';
import {File} from '../../common/fields/file';
import {fieldArts as arts} from '../../artjs/field';

export function createFILE(d) {
  FieldEvent[d.fieldName] = new File(d);
  FieldEvent[d.fieldName].uploadCallback = (o) => {
    renderFILE(d.fieldName);
  };
  return FieldEvent[d.fieldName];
}

export function renderFILE(d){
  const field = FieldEvent[d];
  if(!field.dom){
    field.dom = document.getElementById(`sk-field-${d}`);
  }
  if(field.dom){
    field.dom.innerHTML = arts[field.displayType == 7 ? 'FIELDIMG' : 'FIELDFILE'].pc({field: field});
  }
}

export function changeFILE(e, d) {
  FieldEvent[d].upload(e.files[0]);
  renderFILE(d);
}

export function clearFILE(e, d) {
  FieldEvent[d].setValue(null);
  renderFILE(d);
}